module.exports = __webpack_public_path__ + "img/student-onboarding-2-bg.bcf62d18.svg";